const css = `.VlbsJq__groupedInputTop{border-radius:var(--sizing-border-radius-small)var(--sizing-border-radius-small)0 0}.VlbsJq__groupedInputBottom{border-radius:0 0 var(--sizing-border-radius-small)var(--sizing-border-radius-small);margin-top:-1px}.VlbsJq__groupedInputMiddle{border-radius:0;margin-top:-1px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"groupedInputTop":"VlbsJq__groupedInputTop","groupedInputBottom":"VlbsJq__groupedInputBottom","groupedInputMiddle":"VlbsJq__groupedInputMiddle"};
